export default __webpack_public_path__ + "static/media/black-friday-on.74203780.svg";